
import Typography from '@mui/material/Typography';


export const TextDrugCapecitabine = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Capecitabine is used in combination with other medications to treat breast cancer that has come back after treatment with other medications. 
It is also used alone to treat breast cancer that has not improved after treatment with other medications. Capecitabine is also used to treat colon or 
rectal cancer (cancer that begins in the large intestine) that has gotten worse or spread to other parts of the body. It is also used to prevent colon cancer 
from spreading in people who have had surgery to remove the tumor. Capecitabine is in a class of medications called antimetabolites. It works by stopping or 
slowing the growth of cancer cells.
<br /><br />


Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a699003.html

</Typography>

</div>

)
}